'use client';

import type { FunctionComponent } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

type Props = {
    pageParam?: string;
    queryParam?: string;
    className?: string;
};

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1'.split('');
const FilterByLetter: FunctionComponent<Props> = ({ pageParam = 'page', queryParam = 'l', className = '' }) => {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const selected = searchParams?.get(queryParam);

    const handleSelect = (l: string) => {
        const params = new URLSearchParams(searchParams?.toString());

        if (params.get(queryParam) === l) {
            params.delete(queryParam);
        } else {
            params.set(queryParam, l);
        }

        if (pageParam) {
            params.delete(pageParam);
        }
        router.push(`${pathname}?${params.toString()}`);
    };

    return (
        <div className={`relative h-12 overflow-scroll bg-white ${className || ''}`}>
            <ul className="text-dark-green/50 absolute flex h-12 flex-row flex-nowrap items-center gap-1 lg:w-full lg:flex-wrap lg:px-4">
                {LETTERS.map((l) => (
                    <li
                        className={`w-12 cursor-pointer text-center ${
                            selected === l ? ' text-dark-green' : ''
                        } lg:w-auto lg:flex-1`}
                        key={l}
                        onClick={() => handleSelect(l)}>
                        {l === '1' ? '#' : l}
                    </li>
                ))}
            </ul>
        </div>
    );
};

FilterByLetter.displayName = 'FilterByLetter';

export default FilterByLetter;
